import { Routes, Route } from "react-router-dom";
import { Suspense } from "react";
import { commonRoutes } from "./commonRoutes";
import { privateRoutes } from "./privateRoutes";

const allRoutes = [
    ...commonRoutes,
    ...privateRoutes
];

const renderRoutes = (routes) => {
  return routes.map(({ path, element, children }, index) => (
    <Route key={index} path={path} element={element}>
      {children && renderRoutes(children)}
    </Route>
  ));
};

const LoadingFallback = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    zIndex: 9999
  }}>
    <p className="loading-dots">Loading</p>
  </div>
);

const Router = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>{renderRoutes(allRoutes)}</Routes>
    </Suspense>
  );
};

export default Router;